<template>
  <div class="container">
    <!-- 考试记录 -->
    <div class="test-records-list" v-for="(item,index) in list" :key="index">
      <span>{{item.grade}}</span>
      <span>{{item.createDate | formatDateTime}}</span>
      <span class="red-color" v-if="item.isQualified==1">不合格</span>
      <span class="blue-color" v-if="item.isQualified==0">合格</span>
    </div>
  </div>
</template>

<script>
import { gainitionRecord } from "@/api/training";
import moment from 'moment/moment'
export default {
  data() {
    return {
      list: []
    };
  },
  filters: {
    formatDateTime(value) {
      return moment(value).format('YYYY/MM/DD HH:mm:ss');
    }
  },
  mounted() {
    this.requestGainitionRecord();
  },
  methods: {
    requestGainitionRecord() {
      gainitionRecord().then(res => {
        console.log(res);
        this.list = res.data;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.red-color {
  color: #ff3838;
}
.blue-color {
  color: #008cff;
}
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  .test-records-list {
    width: 350px;
    height: 60px;
    line-height: 50px;
    background-color: #ffffff;
    margin: 10px auto;
    border-radius: 8px;
    span {
      &:nth-of-type(1) {
        width: 20%;
      }
      &:nth-of-type(2) {
        width: 60%;
      }
      &:nth-of-type(3) {
        width: 20%;
      }
      display: inline-block;

      height: 50px;
      line-height: 50px;
      font-size: 14px;
    }
  }
}
</style>
